import { flowUtils } from '@atlassian/mpac-utils';

// NOTE: This type is not exhaustive If any additional fields from the UPM REST API
// are used, please add them to this type def.

// TODO should reused from mpac-api-client once we remove immutable
export const foldPaymentModel = p => (free, atlassian, vendor) => {
  switch (p) {
    case 'PAID_VIA_ATLASSIAN':
      return atlassian();
    case 'FREE':
      return free();
    case 'PAID_VIA_PARTNER':
      return vendor();
    default:
      throw flowUtils.unexpectedCase(p);
  }
};

// TODO should reused from mpac-api-client once we remove immutable

export function makeAppKey(key) {
  return key;
}